const config = {
  appName: parse(process.env.VUE_APP_NAME, 'TripCircuit'),
  appEnvironment: parse(process.env.VUE_APP_ENVIRONMENT, 'production'),
  amadeusEnvironment: parse(process.env.VUE_APP_AMADEUS_ENVIRONMENT, 'sandbox'),
  appVersion: parse(process.env.VUE_APP_VERSION, '1.0.0'),
  apiBaseUrl: parse(process.env.VUE_APP_API_BASE_URL,  'http://localhost:8081'),
  locale: parse(process.env.VUE_APP_LOCALE, 'en'),
  sso: {
    enabled: parse(process.env.VUE_APP_SSO_ENABLED, false)
  },
  googleKey: parse(process.env.VUE_APP_API_GOOGLE_KEY, null),

  // HuddleLabs API
  huddlelabsApiBaseUrl: parse(process.env.VUE_APP_HUDDLELABS_API_BASE_URL, null),
  huddlelabsApiUsername: parse(process.env.VUE_APP_HUDDLELABS_API_USERNAME, null),
  huddlelabsApiPassword: parse(process.env.VUE_APP_HUDDLELABS_API_PASSWORD, null),
  previewMode: parse(process.env.VUE_APP_PREVIEW_MODE, null),
  currentVersionIndicatorUrl: parse(process.env.VUE_APP_CURRENT_VERSION_INDICATOR_URL, 'https://version.tripcircuit.com'),


  // logout timers
  timeWarning: parse(process.env.VUE_APP_WARNING_MINUTES*60000, 960000),
  timeLogout: parse(process.env.VUE_APP_LOGOUT_MINUTES*60000, 900000),
  timeRefresh: parse(process.env.VUE_APP_REFRESH_MINUTES*60000, 900000),
  routerTimer: parse(process.env.VUE_APP_ROUTER_TIMER_MINUTES*60000, 900000),

  // PNR timers
  updatingTimePNR: parse(process.env.VUE_APP_UPDATE_PNR_SEC*1000, 120000),
  timeLimitPNR: parse(process.env.VUE_APP_TIME_LIMIT_PNR_SEC*1000, 500),

  features: {
  },

  // GantGateway
  gantGatewayUrl: parse(process.env.VUE_APP_GANT_GATEWAY_URL, 'https://gantgateway.com'),
  gantGatewayUrlWithProxy: parse(process.env.VUE_APP_GANT_GATEWAY_URL_PROXY, 'https://gantgateway.com'),
  gantGatewayClientId: parse(process.env.VUE_APP_GANT_GATEWAY_CLIENT_ID, null),
  gantGatewayClientSecret: parse(process.env.VUE_APP_GANT_GATEWAY_CLIENT_SECRET, null),
  gantGatewayGrantType: parse(process.env.VUE_APP_GANT_GATEWAY_GRANT_TYPE, 'password'),
  gantGatewayScope: parse(process.env.VUE_APP_GANT_GATEWAY_SCOPE, '*'),

  // TalkDesk
  talkDeskTouchpointId: parse(process.env.VUE_APP_TALKDESK_TOUCHPOINT_ID, null),
  talkDeskAiTouchpointId: parse(process.env.VUE_APP_TALKDESK_AI_TOUCHPOINT_ID, null),
  isChatEnabled: parse(process.env.VUE_APP_CHAT_ENABLED, false),

  // Auth0 – used for self-registration login setup (PKCE, no client secret required)
  auth0Domain:           parse(process.env.VUE_APP_AUTH0_DOMAIN, null),
  auth0ClientId:         parse(process.env.VUE_APP_AUTH0_CLIENT_ID, null),
  auth0Audience:         parse(process.env.VUE_APP_AUTH0_AUDIENCE, null),
  auth0CallbackUrl:      parse(process.env.VUE_APP_AUTH0_CALLBACK_URL, null),
  auth0LoginCallbackUrl: parse(process.env.VUE_APP_AUTH0_LOGIN_CALLBACK_URL, null),
  auth0PasswordlessConnection: parse(process.env.VUE_APP_AUTH0_PASSWORDLESS_CONNECTION, 'email'),

}
function feature (name) {
  return config.features[name]
}
function parse (value, fallback) {
  // // console.log(value)
  if (typeof value === 'undefined') {
    return fallback
  }
  switch (typeof fallback) {
    case 'boolean' :
      return !!JSON.parse(value)
    case 'number' :
      return JSON.parse(value)
    default :
      return value
  }
}
export {
  config
}
export default {
  install (Vue) {
    Vue.appConfig = config
    Vue.feature = feature
    Vue.prototype.$appConfig = config
    Vue.prototype.$feature = feature
  }
}
